import { LoadingSpinner } from '@/components/loading-spinner/loading-spinner'

import { cn } from '@/lib/utils'

export const CheckNvcCaseLoader = () => {
  return (
    <div className={cn('flex items-center justify-center', 'h-[56px] w-full', 'p-4', 'rounded-md border border-input')}>
      <LoadingSpinner />
    </div>
  )
}
